// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.btn[data-v-6ac9f802]{\r\n  color: white !important;\r\n  margin: 5px;\r\n  width: 100px;\n}\n.backgroundSetting[data-v-6ac9f802] {\r\n  background-color: var(--BackgroundColor);\r\n  background-image: var(--BackgroundImageUrl);\r\n  background-position: var(--BackgroundPosition);\r\n  background-repeat: var(--BackgroundRepeat);\n}\r\n", ""]);
// Exports
module.exports = exports;
